module.exports = __webpack_public_path__ + "static/media/logoCoruja.a9b10571.png";